import axios from "axios";
import router from "@/router";
import crypto from "@/assets/js/encrypt";

const instance = axios.create({
  baseURL: process.env.VUE_APP_API_URL_PYTHON,
  timeout: 60000,
  headers: {
    "Content-Type": "application/json"
  }
});

console.log('Python环境BaseURL:', instance.defaults.baseURL);

instance.interceptors.request.use(
  (config) => {
    try {
      const timestamp = Date.now() + 1000 * 60 * 1;
      const token = localStorage.getItem("token") || "";

      let signData = {};
      if (config.method?.toLowerCase() === "post" && config.data) {
        signData = { ...config.data, timestamp };
      } else if (config.method?.toLowerCase() === "get" && config.params) {
        signData = { ...config.params, timestamp };
        config.params = { ...config.params, timestamp };
      } else {
        signData = { timestamp };
      }

      const sign = crypto.generateSign(signData);

      config.headers = {
        ...config.headers,
        token,
        timestamp: timestamp.toString(),
        sign
      };

      // 添加调试信息
      console.log(`[Python API] 请求: ${config.baseURL}${config.url}`);
      
      return config;
    } catch (error) {
      console.error("Python API 请求拦截器错误:", error);
      return Promise.reject(error);
    }
  },
  (error) => {
    console.error("Python API 请求配置错误:", error);
    return Promise.reject(error);
  }
);

instance.interceptors.response.use(
  (response) => {
    console.log(`[Python API] 响应:`, response.config.url, response.data);
    const { data } = response;
    
    if ([20001, 2].includes(data?.code)) {
      sessionStorage.clear();
      localStorage.clear();
      router.replace("/login");
      return Promise.reject(new Error("Token已过期"));
    }

    return data;
  },
  (error) => {
    console.error(`[Python API] 请求错误:`, error.config?.url, error.message);
    return Promise.reject(error);
  }
);

export default instance;